module.exports = "/images/twitter-retweet.svg?4a2aed8b868958e7ea9ab4c6ab21f711";